import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import { classNames } from '../../../utils/classNames';
import { useAuthWithAgentMutation, useSignInWithAgentMutation } from '../../../store/auth/authApi';
import { useNavigate, useParams } from 'react-router-dom';
import TypingMessage from '../../../components/shared/typing-message/TypingMessageAuth';

const ChatContent = () => {
	const {id} = useParams();
	const navigate = useNavigate();
	const [authWithAgent] = useAuthWithAgentMutation()

	const [signInAgent] = useSignInWithAgentMutation()
	const {authMessages, error, isAdmin, isLoggedIn} = useSelector(
		(state: RootState) => state.chats
	);

	const getAuthMessages = () => authWithAgent({linkToken: id || '', chatData: []}).unwrap();
	const getAuthSignInMessages = (usedBefore?: boolean) => signInAgent(usedBefore ? {chatData: [], usedBefore} : {chatData: []}).unwrap();

	const chatEndRef = useRef<HTMLDivElement>(null);
	const scrollToBottom = () => setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100)

	useEffect(() => {
		if (id) {
			getAuthMessages()
		} else {
			getAuthSignInMessages(Boolean(localStorage.getItem('authText')))
		}
	},[id]);

	useEffect(() => {
		if (isLoggedIn) {
			if (isAdmin) {
				window.location.href = process.env.REACT_APP_EMPLOYEE_URL || '/'
			} else {
				setTimeout(()=>{
					navigate('/')
				}, 500)
			}
			
		}
		scrollToBottom();
	},[authMessages, isAdmin, isLoggedIn]);

	return (
		<div className='h-[60vh] md:h-[50vh] w-full overflow-auto bg-[#F7F1DA] p-5 flex flex-col text-primary-dark'>
			{authMessages?.map(
				(conversation, index: number) => (
					<div key={conversation.agent?.message || conversation.user?.message + conversation._id + index}  className='my-2 flex'>
						{conversation.agent ? 
						<div className='w-full flex flex-row'>
							<img alt='avatar' width={34} height={34} className='rounded-full mr-2' src='/svg/auth/avatar.svg' />
							<div className='bg-white dark:bg-black dark:text-white max-w-[95%] rounded-2xl p-4'>
								{conversation.agent.message && <TypingMessage message={conversation.agent.message} typingSpeed={500} isAuth />}
							</div>
						</div>
						: 
						<div className={classNames('bg-primary-default max-w-[90%] text-white rounded-2xl p-4 ml-auto break-words',
						 conversation.user.type === 'pending' ? 'opacity-50': '',
						 conversation.user.type === 'error' ? 'border-2 border-red-500 opacity-60': ''
						)}
						 >
							{conversation.user.message}
						</div>
				}
					</div>
				)
			)}
			<p className='text-red-400'>{error}</p>
			<div ref={chatEndRef} />
		</div>
	)
}

export default ChatContent;